import { isValidUrl } from 'src/app/core/functions/common-functions';
import { MOCEventInput } from 'src/app/model/crm/moc-event-input';
import { MOCEvent } from 'src/app/model/crm/moc-event';
import { MOCEventCatInput } from 'src/app/model/admin/moc-event-cat-input';
import { MOCEventCategory } from 'src/app/model/crm/moc-event-category';
import { isNullOrUndefined } from 'src/app/utils/utils';

export function isValidMocEventInput(
  input: MOCEventInput,
  event: MOCEvent | null = null
): any {
  let areDatesInvalid = false;
  if (input.startDt && input.endDt) {
    areDatesInvalid = new Date(input.startDt) > new Date(input.endDt);
  } else if (event && input.startDt && !input.endDt) {
    areDatesInvalid = new Date(input.startDt) > new Date(event.endDt);
  } else if (event && input.endDt && !input.startDt) {
    areDatesInvalid = new Date(event.startDt) > new Date(input.endDt);
  }

  if (areDatesInvalid) {
    return 'COMMON.MESSAGES.ERROR.START_DATE_GREATER_THAN_END';
  }

  if (!input.MOCEventAORs || input.MOCEventAORs.length == 0) {
    return 'CRM.MESSAGES.ERROR.MISSING_AOR';
  }

  if (
    !input.MOCEventAssociatedCategories ||
    input.MOCEventAssociatedCategories.length == 0
  ) {
    return 'CRM.MESSAGES.ERROR.MISSING_CATEGORIES';
  }

  const urlToDoc = input.document;
  if (urlToDoc && !isValidUrl(urlToDoc)) {
    return 'CRM.MESSAGES.ERROR.INVALID_URL';
  }

  return null;
}

export function isValidMocEventCategoryInput(
  input: MOCEventCatInput | null,
  categories: MOCEventCategory[]
): any {
  if (!isNullOrUndefined(categories) && input) {
    const isDuplicate = categories.find((c) => c.name === input.name);
    if (!isNullOrUndefined(isDuplicate)) {
      return 'CRM.MESSAGES.ERROR.DUPLICATE_CATEGORY';
    }
  }

  return null;
}

export function verifyMOCEventCategoryStillValid(
  changes: any,
  categories: any[]
): boolean {
  let stillExistAndEnabled = false;
  if (changes && changes.eventCategories && categories) {
    categories.forEach((category) => {
      if (changes.eventCategories.includes(category.value)) {
        stillExistAndEnabled = true;
      }
    });
    return stillExistAndEnabled;
  } else {
    return stillExistAndEnabled;
  }
}

export function getMostRecentMOCEventsInList(data: MOCEvent[]): MOCEvent[] {
  const recent = new Map<string, MOCEvent>();
  if (data) {
    data.forEach((event) => {
      if (recent.size === 0) {
        if (!event.parentMocId) {
          recent.set(event.id, event);
        } else {
          recent.set(event.parentMocId, event);
        }
      } else {
        if (!event.parentMocId) {
          if (!recent.has(event.id)) {
            recent.set(event.id, event);
          }
        } else {
          if (recent.has(event.parentMocId)) {
            if (recent.get(event.parentMocId)!.historyId < event.historyId) {
              recent.set(event.parentMocId, event);
            }
          } else {
            recent.set(event.parentMocId, event);
          }
        }
      }
    });

    const retVal: MOCEvent[] = [];
    recent.forEach((event) => {
      retVal.push(event);
    });
    return retVal;
  } else {
    return [];
  }
}
